<div *ngIf="shareObj" class="share-map">
    <div class="map-title">
        <label class="pull-left control-label">{{ shareObj.length > 1 ? 'Maps' : 'Map' }}:</label>
        <ul *ngFor="let s of shareObj; let i = index" style="padding-left:75px; margin-top: 5px">
            <li>
                <a  target="_blank" [href]="mapUrls !== undefined ? mapUrls[i] : '#'" rel="noopener">
                    {{ s.title || 'New Map' }}
                </a>
            </li>
        </ul>
    </div>
    <div *ngIf="loading.status">
        <div class="loader is-active padding-leader-3 padding-trailer-3">
            <div class="loader-bars"></div>
            <div class="loader-text">{{ loading.text }}</div>
        </div>
    </div>
    <div #shareMapForm *ngIf="!loading.status">
        <p class="alert alert-yellow is-active share-warning" *ngIf="mustSave">
            <strong>Warning:</strong> You must save {{ shareObj.length > 1 ? 'these maps' : 'this map' }} before it can be shared.
            <button type="button" class="btn btn-primary" (click)="saveMaps()">
                Save
                <i class="icon-ui-save"></i>
            </button>
        </p>
        <p class="alert alert-yellow is-active" *ngIf="mustSaveUnsaved">
            <strong>Warning:</strong> Your map has unsaved changes. Would you like to save
            your changes before sharing this map?
            <button type="button" class="btn btn-primary pull-right" (click)="saveMaps()">
                Save <i class="icon-ui-save"></i>
            </button>
        </p>
        <p class="alert alert-red is-active" *ngIf="error">
            <button type="button" class="close" (click)="resetError()"><span aria-hidden="true">&times;</span></button>
            <strong>Error:</strong> {{ error }}.
        </p>
        <p class="alert alert-yellow is-active" *ngIf="warn">
            <button type="button" class="close" (click)="resetWarning()">
                <span aria-hidden="true">&times;</span>
            </button>
            <strong>Warning:</strong> Your map has been shared, but we were unable to deliver
            an email to the following recipients: <a href="mailto:{{recipient}}"
                                                     *ngFor="let recipient of warn.recipients">{{ recipient }}</a>
        </p>
        <p class="alert alert-full is-active" *ngIf="info">
            <button type="button" class="close" (click)="resetInfo()"><span aria-hidden="true">&times;</span></button>
            <strong>Info:</strong> This map has already been shared with <a href="mailto:{{ info.recipient }}">{{ info.recipient }}</a>.
        </p>
        <div class="alert alert-yellow is-active" *ngIf="requireSaveCopy">
            <strong>Warning:</strong>
            You do not own these maps:
            <ul>
                <li *ngFor="let map of unownedMaps; let i = index">
                    {{ map.title }}
                </li>
            </ul>
            You must save a copy of each to share this map with other users.
            <button type="button" class="btn btn-small pull-right" (click)="saveMaps()">
                Save Copy <i class="icon-ui-save"></i>
            </button>
        </div>
        <div class="alert alert-red is-active unshareableMapList" *ngIf="unshareableMaps">
            <strong>Error:</strong> The selected maps have non-public layers and cannot be shared:
            <ul>
                <li *ngFor="let unshareableMap of unshareableMaps">
                    {{ unshareableMap.name }}
                    <ul>
                        <li *ngFor="let layer of unshareableMap.layers">
                            {{ layer }}
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <p class="alert alert-green is-active" *ngIf="success">
            <strong>Success:</strong> Your map has been shared.
        </p>

        <div class="control-group clearfix">
            <label class="pull-left control-label">To:</label>
            <div class="pull-right field search">

                <div>
                    <input type="text" placeholder="Search by name or email address" [(ngModel)]="inputSearchText"
                           (ngModelChange)="outputSearchText.next(inputSearchText)" [disabled]="disableForm">
                    <i class="icon-ui-loading-indicator" *ngIf="loadingEmails"></i>
                    <button type="button" class="btn btn-small" *ngIf="showAddButton"
                            (click)="addFreeFormRecipient(inputSearchText)">
                        Add
                        <i class="icon-ui-plus"></i>
                    </button>
                </div>

                <div class="returnedUserList" *ngIf="inputSearchText">
                    <div *ngFor="let user of shareCandidates" (click)="selectUser(user)">
                        {{ user.firstName }} {{ user.lastName }} - {{ user.department }}
                        <ng-container *ngIf="canViewCWOPAData">
                            - {{ user.email }}
                        </ng-container>
                    </div>
                    <div *ngIf="!loadingEmails && (!shareCandidates || !shareCandidates.length)">
                        {{ shareCandidatesError || 'No Users Found' }}
                    </div>
                </div>

                <!--<div class="ad-checkbox-container">
                    <label title="May slow the search">
                        <input type="checkbox" [(ngModel)]="includeADGroups" style="margin-top: 2px;"> Include Active
                        Directory Groups
                    </label>
                </div>-->

            </div>
        </div>

        <div class="control-group clearfix">
            <label class="control-label pull-left">Message:</label>
            <div class="pull-right field">
                <textarea name="message" [(ngModel)]="email.message" rows="3" placeholder="Message"
                          [disabled]="disableForm"></textarea>
            </div>
        </div>

        <div class="clearfix control-group">
            <label class="control-label pull-left">Recipients:</label>
            <div class="pull-right field">
                <table class="recipientList">
                    <tbody>
                        <tr *ngIf="noRecipient">
                            <td>None</td>
                        </tr>
                        <tr *ngFor="let recipient of email.recipients">
                            <!-- Normal -->
                            <td *ngIf="recipient.id >= 0">{{ recipient.firstName || 'NA' }}</td>
                            <td *ngIf="recipient.id >= 0">{{ recipient.lastName || 'NA' }}</td>
                            <td *ngIf="recipient.id >= 0">{{ recipient.email }}</td>

                            <!-- Active Directory Group -->
                            <td *ngIf="recipient.id < 0" colspan="3" style="width: auto;">
                                {{ recipient.firstName }}
                                <div style="float: right; margin-right: 15px;">
                                    <span>{{ recipient.groupMembers.length }} Members</span>
                                </div>
                            </td>

                            <td style="width: 89px;">
                                <button type="button" class="btn btn-danger btn-xs"
                                        (click)="removeRecipient(recipient)">
                                    <i class="icon-ui-close-circled remove"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<div class="footer text-right">
    <button class="btn share" (click)="selectShareMap()" [disabled]="noRecipient">Share</button>
    <button class="btn btn-clear cancel" (click)="close()">Close</button>
</div>
